ixModuleRouting("impactx.productstock", {
    "/productstocklist/:id?": {
        template: "<ixa-product-stock-list></ixa-product-stock-list>",
        templateUrl: "modules/productstock/templates/productstocklist.html",
        process: "ManageStockAmounts",
        controller: "ProductStockListController",
        controllerAs: "productStockListController",
        workspace: "content",
    },
    "/allproductstocklist": {
        template:"<ixa-all-product-stock-list></ixa-all-product-stock-list>",
        templateUrl: "modules/productstock/templates/allproductstocklist.html",
        process: "ManageStockAmounts",
        controller: "AllProductStockListController",
        controllerAs: "allProductStockListController",
        workspace: "content",
    },
    "/productstockconsolidate": {
        template:"<ixa-product-stock-consolidate></ixa-product-stock-consolidate>",
        process: "ManageStockAmounts",
        workspace: "content",
    },
    "/productstockseparate/:id": {
        template:"<ixa-separate-stock-details></ixa-separate-stock-details>",
        process: "ManageStockAmounts",
        workspace: "content",
    },
});
